import {RoundModel} from "../../features/round/roundTypes";
import React from "react";

type Props = {
    round: RoundModel;
};



const SeasonRoundItem = ({round}: Props) => {

    return (

        <div>{round.name}</div>


)
}

export default SeasonRoundItem;